import React from 'react';

import { Skeleton } from '@material-ui/lab';

import { ITaskData } from '~/store/modules/tasks/types';

import TimerImg from '../../../assets/Timer.svg';
import CorrectImg from '../../../assets/Correct.svg';
import EyeImg from '../../../assets/Eye.svg';
import {
  Container,
  StatusLabel,
  TotalValue,
  StatusesBar,
  StatusesBarSkeleton,
} from './styles';

interface Props {
  data: ITaskData[];
}

const StatusBar: React.FC<Props> = ({ data }) => {
  function chooseICon(taskChart: any) {
    if (taskChart.name === 'Atrasadas') {
      return TimerImg;
    }
    if (taskChart.name === 'Próximas a vencer') {
      return EyeImg;
    }
    if (taskChart.name === 'No prazo') {
      return CorrectImg;
    }
  }

  return (
    <Container>
      {data && data.length > 0 ? (
        data.map((taskChart) => {
          return (
            <div className="content">
              <img
                src={chooseICon(taskChart)}
                style={{ width: '30px', height: '30px' }}
                alt=""
              />
              <StatusesBar key={taskChart.name}>
                <TotalValue>{taskChart.value}</TotalValue>
                <StatusLabel>{taskChart.name}</StatusLabel>
              </StatusesBar>
            </div>
          );
        })
      ) : (
        <StatusesBarSkeleton>
          <Skeleton animation="wave" variant="rect" height={150} width="30%" />
          <Skeleton animation="wave" variant="rect" height={150} width="30%" />
          <Skeleton animation="wave" variant="rect" height={150} width="30%" />
        </StatusesBarSkeleton>
      )}
    </Container>
  );
};

export default StatusBar;
